import React from 'react';

import { BsSearch } from "react-icons/bs";
import { BiChevronDownCircle } from "react-icons/bi";
import { faqslist } from './Faqslist';

import {
  HeadingSection,
  Strong,
  SubTitle,
  SearchSection,
  SearchInput,
} from './../Tutorials/styled';

import {
  StyledFaqSection,
  FaqsHeroSection,
  FaqsTitle,
  FaqsWrapper,
  StyledFaqDetails,
  StyledFaqSummary,
  StyledFaqParagraph,
} from './styled';

const Faqs = () => {
  return (
    <StyledFaqSection>
      <FaqsHeroSection>
        <HeadingSection>
          <SubTitle>FAQs</SubTitle>
          <FaqsTitle>Frequently Asked <Strong>Questions</Strong></FaqsTitle>
          <SubTitle className='hideonMobile'>Have a question? We're here to help.</SubTitle>
          <SearchSection>
            <BsSearch />
            <SearchInput placeholder='Search Here' />
          </SearchSection>
        </HeadingSection>
      </FaqsHeroSection>
      <FaqsWrapper>
        {
          faqslist.map((data) => (
            <StyledFaqDetails key={data.id}>
              <StyledFaqSummary>
                {data.summary}
                <BiChevronDownCircle />
              </StyledFaqSummary>
              <StyledFaqParagraph><span>{data.description}</span></StyledFaqParagraph>
            </StyledFaqDetails>
          ))
        }
      </FaqsWrapper>
    </StyledFaqSection>
  )
}

export default Faqs;